module.exports = __webpack_public_path__ + "static/img/remove.3a58015.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lite/icon/remove.svg
// module id = Twfd
// module chunks = 2